function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "Interpolation", () => $e3e2971203022b54$export$2e2bcd8739ae039);
$parcel$export(module.exports, "RubberBanding", () => $47bfed8c5aa73889$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Rect", () => $4d2286c4c2bf13cd$export$c79fc6492f3af13d);
$parcel$export(module.exports, "Size", () => $4d2286c4c2bf13cd$export$cb6da89c6af1a8ec);
$parcel$export(module.exports, "Point", () => $4d2286c4c2bf13cd$export$baf26146a414f24a);
$parcel$export(module.exports, "Edge", () => $4d2286c4c2bf13cd$export$b9d9805c9b77a56d);
$parcel$export(module.exports, "EdgeInsets", () => $4d2286c4c2bf13cd$export$45cce0bd6c1f342a);
$parcel$export(module.exports, "Path2D", () => $e2b259e740dd748e$export$2e2bcd8739ae039);
// 
// index.js
// Cacao
// 
// Created on 7/4/23
// 
// 
// Geometry.js
// Cacao
// 
// Created on 9/8/22
// 
class $4d2286c4c2bf13cd$export$c79fc6492f3af13d {
    origin = $4d2286c4c2bf13cd$export$baf26146a414f24a.zero;
    size = $4d2286c4c2bf13cd$export$cb6da89c6af1a8ec.zero;
    static make(x, y, width, height) {
        return new $4d2286c4c2bf13cd$export$c79fc6492f3af13d(new $4d2286c4c2bf13cd$export$baf26146a414f24a(x, y), new $4d2286c4c2bf13cd$export$cb6da89c6af1a8ec(width, height));
    }
    static from(rect) {
        if (!rect) return undefined;
        return $4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(rect.origin.x, rect.origin.y, rect.size.width, rect.size.height);
    }
    static get zero() {
        return $4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(0, 0, 0, 0);
    }
    static get null() {
        return $4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(Infinity, Infinity, 0, 0);
    }
    constructor(origin, size){
        this.origin = $4d2286c4c2bf13cd$export$baf26146a414f24a.from(origin);
        this.size = $4d2286c4c2bf13cd$export$cb6da89c6af1a8ec.from(size);
    }
    equals(rect) {
        rect = $4d2286c4c2bf13cd$export$c79fc6492f3af13d.from(rect);
        return this.origin.x == rect.origin.x && this.origin.y == rect.origin.y && this.size.width == rect.size.width && this.size.height == rect.size.height;
    }
    copy() {
        return $4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(this.origin.x, this.origin.y, this.size.width, this.size.height);
    }
    offsetBy(dx, dy) {
        return $4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(this.origin.x + dx, this.origin.y + dy, this.size.width, this.size.height);
    }
    insetBy(dx, dy) {
        return $4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(this.origin.x + dx, this.origin.y + dy, this.size.width - 2 * dx, this.size.height - 2 * dy);
    }
    insetByEdgeInsets(edgeInsets) {
        edgeInsets = $4d2286c4c2bf13cd$export$45cce0bd6c1f342a.from(edgeInsets);
        return $4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(this.origin.x + edgeInsets.left, this.origin.y + edgeInsets.top, this.size.width - edgeInsets.left - edgeInsets.right, this.size.height - edgeInsets.top - edgeInsets.bottom);
    }
    divide(slice, remainder, amount, edge) {
        slice.origin = this.origin.copy();
        slice.size = this.size.copy();
        remainder.origin = this.origin.copy();
        remainder.size = this.size.copy();
        switch(edge){
            case $4d2286c4c2bf13cd$export$b9d9805c9b77a56d.minX:
                slice.size.width = amount;
                remainder.origin.x += amount;
                remainder.size.width -= amount;
                break;
            case $4d2286c4c2bf13cd$export$b9d9805c9b77a56d.maxX:
                slice.origin.x = $4d2286c4c2bf13cd$export$c79fc6492f3af13d.from(slice).maxX - amount;
                slice.size.width = amount;
                remainder.size.width -= amount;
                break;
            case $4d2286c4c2bf13cd$export$b9d9805c9b77a56d.minY:
                slice.size.height = amount;
                remainder.origin.y += amount;
                remainder.size.height -= amount;
                break;
            case $4d2286c4c2bf13cd$export$b9d9805c9b77a56d.maxY:
                slice.origin.y = $4d2286c4c2bf13cd$export$c79fc6492f3af13d.from(slice).maxY - amount;
                slice.size.height = amount;
                remainder.size.height -= amount;
                break;
        }
    }
    containsPoint(aPoint) {
        return aPoint.x >= this.origin.x && aPoint.y >= this.origin.y && aPoint.x < this.maxX && aPoint.y < this.maxY;
    }
    containsRect(rect) {
        const union = this.union(rect);
        return this.equals(union);
    }
    intersects(rect) {
        const intersection = this.intersection(rect);
        return !intersection.isEmpty;
    }
    intersection(rect) {
        rect = $4d2286c4c2bf13cd$export$c79fc6492f3af13d.from(rect);
        const intersection = $4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(Math.max(this.minX, rect.minX), Math.max(this.minY, rect.minY), 0, 0);
        intersection.size.width = Math.min(this.maxX, rect.maxX) - intersection.minX;
        intersection.size.height = Math.min(this.maxY, rect.maxY) - intersection.minY;
        return intersection.isEmpty ? $4d2286c4c2bf13cd$export$c79fc6492f3af13d.zero : intersection;
    }
    union(rect) {
        rect = $4d2286c4c2bf13cd$export$c79fc6492f3af13d.from(rect);
        const thisIsNull = this.isNull, rectIsNull = !rect || rect.isNull;
        if (thisIsNull) return rectIsNull ? $4d2286c4c2bf13cd$export$c79fc6492f3af13d.null : rect;
        if (rectIsNull) return thisIsNull ? $4d2286c4c2bf13cd$export$c79fc6492f3af13d.null : this.copy();
        const minX = Math.min(this.minX, rect.minX), minY = Math.min(this.minY, rect.minY), maxX = Math.max(this.maxX, rect.maxX), maxY = Math.max(this.maxY, rect.maxY);
        return $4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(minX, minY, maxX - minX, maxY - minY);
    }
    get standarized() {
        const { width: width, height: height } = this;
        const standardized = this.copy();
        if (width < 0.0) {
            standardized.origin.x += width;
            standardized.size.width = -width;
        }
        if (height < 0.0) {
            standardized.origin.y += height;
            standardized.size.height = -height;
        }
        return standardized;
    }
    get integral() {
        const rect = this.standarized;
        const x = Math.floor(this.minX), y = Math.floor(this.minY);
        aRect.size.width = Math.ceil(this.maxX) - x;
        aRect.size.height = Math.ceil(this.maxY) - y;
        aRect.origin.x = x;
        aRect.origin.y = y;
        return aRect;
    }
    get width() {
        return this.size.width;
    }
    set width(width) {
        this.size.width = width;
    }
    get height() {
        return this.size.height;
    }
    set height(height) {
        this.size.height = height;
    }
    get x() {
        return this.origin.x;
    }
    set x(x) {
        this.origin.x = x;
    }
    get y() {
        return this.origin.y;
    }
    set y(y) {
        this.origin.y = y;
    }
    get maxX() {
        return this.origin.x + this.size.width;
    }
    get maxY() {
        return this.origin.y + this.size.height;
    }
    get midX() {
        return this.origin.x + this.size.width / 2.0;
    }
    get midY() {
        return this.origin.y + this.size.height / 2.0;
    }
    get minX() {
        return this.origin.x;
    }
    get minY() {
        return this.origin.y;
    }
    get isEmpty() {
        return this.size.width <= 0.0 || this.size.height <= 0.0 || this.origin.x === Infinity || this.origin.y === Infinity;
    }
    get isNull() {
        return this.origin.x === Infinity || this.origin.y === Infinity;
    }
    toString() {
        return `{${this.origin}, ${this.size}}`;
    }
}
class $4d2286c4c2bf13cd$export$baf26146a414f24a {
    x = 0;
    y = 0;
    static get zero() {
        return new $4d2286c4c2bf13cd$export$baf26146a414f24a(0, 0);
    }
    static from(point) {
        return !point ? $4d2286c4c2bf13cd$export$baf26146a414f24a.zero : $4d2286c4c2bf13cd$export$baf26146a414f24a.make(point.x, point.y);
    }
    static make(x, y) {
        return new $4d2286c4c2bf13cd$export$baf26146a414f24a(x, y);
    }
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    equals(point) {
        return this.x == point.x && this.y == point.y;
    }
    copy() {
        return new $4d2286c4c2bf13cd$export$baf26146a414f24a(this.x, this.y);
    }
    toString() {
        return `{${this.x}, ${this.y}}`;
    }
}
class $4d2286c4c2bf13cd$export$cb6da89c6af1a8ec {
    width = 0;
    height = 0;
    static get zero() {
        return new $4d2286c4c2bf13cd$export$cb6da89c6af1a8ec(0, 0);
    }
    static from(size) {
        return !size ? undefined : $4d2286c4c2bf13cd$export$cb6da89c6af1a8ec.make(size.width, size.height);
    }
    static make(width, height) {
        return new $4d2286c4c2bf13cd$export$cb6da89c6af1a8ec(width, height);
    }
    constructor(width, height){
        this.width = width;
        this.height = height;
    }
    equals(size) {
        return this.width == size.width && this.height == size.height;
    }
    copy() {
        return new $4d2286c4c2bf13cd$export$cb6da89c6af1a8ec(this.width, this.height);
    }
    toString() {
        return `{${this.width}, ${this.height}}`;
    }
}
class $4d2286c4c2bf13cd$export$b9d9805c9b77a56d {
    static minX() {
        return 0;
    }
    static minY() {
        return 1;
    }
    static maxX() {
        return 2;
    }
    static maxY() {
        return 3;
    }
}
class $4d2286c4c2bf13cd$export$45cce0bd6c1f342a {
    top = 0;
    left = 0;
    bottom = 0;
    right = 0;
    static get zero() {
        return new $4d2286c4c2bf13cd$export$45cce0bd6c1f342a(0, 0, 0, 0);
    }
    static from(edgeInsets) {
        return !edgeInsets ? undefined : $4d2286c4c2bf13cd$export$45cce0bd6c1f342a.make(edgeInsets.top, edgeInsets.left, edgeInsets.bottom, edgeInsets.right);
    }
    static make(top, left, bottom, right) {
        return new $4d2286c4c2bf13cd$export$45cce0bd6c1f342a(top, left, bottom, right);
    }
    constructor(top = 0, left = 0, bottom = 0, right = 0){
        this.top = top;
        this.left = left;
        this.bottom = bottom;
        this.right = right;
    }
    equals(edgeInsets) {
        const { top: top, left: left, bottom: bottom, right: right } = this;
        return top == edgeInsets.top && left == edgeInsets.left && bottom == edgeInsets.bottom && right == edgeInsets.right;
    }
    copy() {
        const { top: top, left: left, bottom: bottom, right: right } = this;
        return new $4d2286c4c2bf13cd$export$45cce0bd6c1f342a(top, left, bottom, right);
    }
}


// 
// Interpolation.js
// Cacao
// 
// Created on 6/8/23
// 
function $e3e2971203022b54$var$lerp(x, y, a) {
    return x * (1 - a) + y * a;
}
function $e3e2971203022b54$var$clamp(a, min = 0, max = 1) {
    return Math.min(max, Math.max(min, a));
}
function $e3e2971203022b54$var$invlerp(a, b, value) {
    return (value - a) / (b - a);
}
function $e3e2971203022b54$var$range(x1, y1, x2, y2, a) {
    return $e3e2971203022b54$var$lerp(x2, y2, $e3e2971203022b54$var$invlerp(x1, y1, a));
}
var $e3e2971203022b54$export$2e2bcd8739ae039 = {
    lerp: $e3e2971203022b54$var$lerp,
    clamp: $e3e2971203022b54$var$clamp,
    range: $e3e2971203022b54$var$range,
    invlerp: $e3e2971203022b54$var$invlerp
};


// 
// RubberBanding.js
// Cacao
// 
// Created on 5/8/23
// 
function $47bfed8c5aa73889$var$clampedValueUsingRubberBandingParameters(value, parameters) {
    const { coeff: coeff = 0.55, dim: dim } = parameters;
    return (1.0 - 1.0 / (value * coeff / dim + 1.0)) * dim;
}
var $47bfed8c5aa73889$export$2e2bcd8739ae039 = {
    clamp: $47bfed8c5aa73889$var$clampedValueUsingRubberBandingParameters
};


// 
// Path2D.js
// Cacao
// 
// Created on 9/9/22
// 

class $e2b259e740dd748e$var$_Path2D extends Path2D {
    roundedRect(x, y, width, height, cornerRadius, roundedCornerStyle) {
        const rect = (0, $4d2286c4c2bf13cd$export$c79fc6492f3af13d).make(x, y, width, height);
        const { minX: minX, minY: minY, maxX: maxX, maxY: maxY } = rect;
        switch(roundedCornerStyle){
            case "continous":
                const limit = Math.min(width, height) / 2 / 1.52866483;
                const limitedRadius = Math.min(cornerRadius, limit);
                const TOP_LEFT = (x, y)=>{
                    return [
                        minX + x * limitedRadius,
                        minY + y * limitedRadius
                    ];
                };
                const TOP_RIGHT = (x, y)=>{
                    return [
                        maxX - x * limitedRadius,
                        minX + y * limitedRadius
                    ];
                };
                const BOTTOM_RIGHT = (x, y)=>{
                    return [
                        maxX - x * limitedRadius,
                        maxY - y * limitedRadius
                    ];
                };
                const BOTTOM_LEFT = (x, y)=>{
                    return [
                        minX + x * limitedRadius,
                        maxY - y * limitedRadius
                    ];
                };
                const { moveTo: moveTo, lineTo: lineTo, bezierCurveTo: bezierCurveTo } = this;
                moveTo.apply(this, TOP_LEFT(1.52866483, 0.00000000));
                lineTo.apply(this, TOP_RIGHT(1.52866471, 0.00000000));
                bezierCurveTo.apply(this, [].concat(TOP_RIGHT(1.08849323, 0.00000000), TOP_RIGHT(0.86840689, 0.00000000), TOP_RIGHT(0.66993427, 0.06549600)));
                lineTo.apply(this, TOP_RIGHT(0.63149399, 0.07491100));
                bezierCurveTo.apply(this, [].concat(TOP_RIGHT(0.37282392, 0.16905899), TOP_RIGHT(0.16906013, 0.37282401), TOP_RIGHT(0.07491176, 0.63149399)));
                bezierCurveTo.apply(this, [].concat(TOP_RIGHT(0.00000000, 0.86840701), TOP_RIGHT(0.00000000, 1.08849299), TOP_RIGHT(0.00000000, 1.52866483)));
                lineTo.apply(this, BOTTOM_RIGHT(0.00000000, 1.52866471));
                bezierCurveTo.apply(this, [].concat(BOTTOM_RIGHT(0.00000000, 1.08849323), BOTTOM_RIGHT(0.00000000, 0.86840689), BOTTOM_RIGHT(0.06549569, 0.66993493)));
                lineTo.apply(this, BOTTOM_RIGHT(0.07491111, 0.63149399));
                bezierCurveTo.apply(this, [].concat(BOTTOM_RIGHT(0.16905883, 0.37282392), BOTTOM_RIGHT(0.37282392, 0.16905883), BOTTOM_RIGHT(0.63149399, 0.07491111)));
                bezierCurveTo.apply(this, [].concat(BOTTOM_RIGHT(0.86840689, 0.00000000), BOTTOM_RIGHT(1.08849323, 0.00000000), BOTTOM_RIGHT(1.52866471, 0.00000000)));
                lineTo.apply(this, BOTTOM_LEFT(1.52866483, 0.00000000));
                bezierCurveTo.apply(this, [].concat(BOTTOM_LEFT(1.08849299, 0.00000000), BOTTOM_LEFT(0.86840701, 0.00000000), BOTTOM_LEFT(0.66993397, 0.06549569)));
                lineTo.apply(this, BOTTOM_LEFT(0.63149399, 0.07491111));
                bezierCurveTo.apply(this, [].concat(BOTTOM_LEFT(0.37282401, 0.16905883), BOTTOM_LEFT(0.16906001, 0.37282392), BOTTOM_LEFT(0.07491100, 0.63149399)));
                bezierCurveTo.apply(this, [].concat(BOTTOM_LEFT(0.00000000, 0.86840689), BOTTOM_LEFT(0.00000000, 1.08849323), BOTTOM_LEFT(0.00000000, 1.52866471)));
                lineTo.apply(this, TOP_LEFT(0.00000000, 1.52866483));
                bezierCurveTo.apply(this, [].concat(TOP_LEFT(0.00000000, 1.08849299), TOP_LEFT(0.00000000, 0.86840701), TOP_LEFT(0.06549600, 0.66993397)));
                lineTo.apply(this, TOP_LEFT(0.07491100, 0.63149399));
                bezierCurveTo.apply(this, [].concat(TOP_LEFT(0.16906001, 0.37282401), TOP_LEFT(0.37282401, 0.16906001), TOP_LEFT(0.63149399, 0.07491100)));
                bezierCurveTo.apply(this, [].concat(TOP_LEFT(0.86840701, 0.00000000), TOP_LEFT(1.08849299, 0.00000000), TOP_LEFT(1.52866483, 0.00000000)));
                break;
            default:
                if (width < 2 * cornerRadius) cornerRadius = width / 2;
                if (height < 2 * cornerRadius) cornerRadius = height / 2;
                this.moveTo(x + cornerRadius, minY);
                this.arcTo(maxX, minY, maxX, maxY, cornerRadius);
                this.arcTo(maxX, maxY, minX, maxY, cornerRadius);
                this.arcTo(minX, maxY, minX, minY, cornerRadius);
                this.arcTo(minX, minY, maxX, minY, cornerRadius);
                break;
        }
        this.closePath();
    }
}
var $e2b259e740dd748e$export$2e2bcd8739ae039 = $e2b259e740dd748e$var$_Path2D;




//# sourceMappingURL=index.js.map
